<article>
  <header>
    @if (headerIcon(); as headerIcon) {
      <svg [lucideIcon]="headerIcon" [size]="22" />
    }
    @if (headerText()) {
      <span joii-text [size]="6" [weight]="'bold'">{{ headerText() }}</span>
    }
  </header>
  @if (badge()) {
    <joii-status-badge [color]="badgeColor() ?? 'blue'" [content]="badgeText() ?? ''"></joii-status-badge>
  }
  <section #content>
    @if (body()) {
      <p joii-text [size]="4" color="tint2">{{ body() }}</p>
    }
    <ng-content select="[slot=body]"></ng-content>
    @if (avatars().length > 0) {
      <div class="avatars">
        @for (url of avatars(); track url; let i = $index) {
          <div class="avatar-item" [style.z-index]="i + 1">
            <joii-avatar [src]="url" size="44px" />
          </div>
        }
      </div>
    }
    @if (avatars().length === 0 && state() !== 'in-progress') {
      <button
        joii-button
        [iconOnly]="true"
        [icon]="arrowRightIcon"
        [disabled]="state() === 'unavailable' || disabled()"
        tabindex="-1"
      ></button>
    }
  </section>
</article>
